import EventBase from "./EventBase";
import EventID from "./EventID";

class EventObj extends EventBase{
    /**
     * event id 222
     */
    public Code: EventID = EventID.Obj

    constructor(){
        super()
        this.Parameter = [
            "0", "=" , "0@1"
        ]
    }

    /**
     * 获取索引 - 0
     */
    get ObjIndex (){
        if (this.Parameter !== undefined && this.Parameter.length >= 1){
            return this.Parameter[0]
        } else {
            return ""
        }
    }

    /**
     * 设置索引 - 0
     */
    set ObjIndex(index:string){
        if (this.Parameter !== undefined && this.Parameter.length >= 1){
            this.Parameter[0] = index
        }
    }

    /**
     * 获取操作符 - 1
     */
    get Operation(){
        if (this.Parameter !== undefined && this.Parameter.length >= 2){
            return this.Parameter[1]
        } else {
            return ""
        }
    }

    /**
     * 设置操作符 - 1
     */
    set Operation(opreate:string){
        if (this.Parameter !== undefined && this.Parameter.length >= 2){
            this.Parameter[1] = opreate
        }
    }

    /**
     * 获取被操作数( 例子: 0@1|2@1 参考 Scene 传入和传出参数) - 2
     */
    get Operand():{type:string, value: string}[]{
        if (this.Parameter !== undefined && this.Parameter.length >= 3){
            const outputParams = this.Parameter[1].split('|')
            return outputParams.map(val => ({ type: val.split('@')[0],  value: val.split('@')[1] }))
        }
        return []
    }

    /**
     * 设置操作数( 例子: 0@1|2@1 参考 Scene 传入和传出参数) - 2
     */
    set Operand(val: {type:string, value: string}[]){
        const str = val.reduce((acc, cur, index, array) => {
            var ex = index < array.length - 1 ? `${cur.type}@${cur.value}|` : `${cur.type}@${cur.value}`
            return acc + ex
        },"") 
        this.Parameter[2] = str
    }


    get Description() {
        return `实例操作 [${this.Parameter[0]}] `
    }
}
export default EventObj